var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getReq } from "../../request";
import { KB_COLLECTION_CHILDREN_BY_ID } from "../../globals";
var CollectionItem = function (props) {
    var collection = props.collection, onCollectionClick = props.onCollectionClick, onCollectionClickStart = props.onCollectionClickStart;
    var getImmediateChildren = function () {
        // Call the start callback to show loading state
        if (onCollectionClickStart) {
            onCollectionClickStart(collection.id);
        }
        var wait = getReq(KB_COLLECTION_CHILDREN_BY_ID + "/" + collection.id, {})
            .then(function (response) {
            if (response && response.data) {
                // Extract immediate children from the response
                var childItems = response.data || [];
                // Call the parent callback with the collection ID and its children
                onCollectionClick(collection.id, childItems);
            }
        })
            .catch(function (e) {
            console.log("Error fetching collection children:", e);
            // Even on error, call the callback with empty children to hide loading
            onCollectionClick(collection.id, []);
        });
        return wait;
    };
    // @ts-ignore
    return (_jsxs("div", __assign({ className: "help__collections-list-item", onClick: getImmediateChildren }, { children: [_jsxs("div", __assign({ className: "help__collections-list-content" }, { children: [_jsx("h6", { children: collection.title }), _jsx("p", { children: collection.description }), _jsx("div", { children: _jsxs("span", __assign({ className: "text-gray" }, { children: [collection.articles_length, " article", (collection.articles_length && collection.articles_length > 1) && "s"] })) })] })), _jsx("div", __assign({ className: "help__collections-list-arrow" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, { children: _jsx("path", { d: "M5.42773 4.70898C5.46387 4.85254 5.53809 4.98828 5.65039 5.10059L8.54932 8L5.64893 10.9004C5.31689 11.2324 5.31689 11.7705 5.64893 12.1025C5.98096 12.4336 6.51904 12.4336 6.85107 12.1025L10.3516 8.60059C10.5591 8.39355 10.6367 8.10449 10.585 7.83691C10.5537 7.67578 10.4761 7.52246 10.3516 7.39844L6.85254 3.89941C6.52051 3.56738 5.98242 3.56738 5.65039 3.89941C5.43066 4.11816 5.35645 4.42871 5.42773 4.70898Z", fill: "#000000" }) })) }))] })));
};
export default CollectionItem;
